import { render, staticRenderFns } from "./detailTransaction.vue?vue&type=template&id=8f66112a&"
import script from "./detailTransaction.vue?vue&type=script&lang=js&"
export * from "./detailTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports